import { render } from "./IconMenuManual.vue?vue&type=template&id=237bea97"
import script from "./IconMenuManual.vue?vue&type=script&lang=ts"
export * from "./IconMenuManual.vue?vue&type=script&lang=ts"
script.render = render

export default script